import { Button } from '@ytl/common-web';
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useLanguage } from '../../contexts/languageContext';
import { AppRoutes } from '../../routes';

export type RegisterYoloOtpWebViewProps = {
  isLoading: boolean;
  setIsLoading: (value: boolean) => void;
  onSendAgain: () => Promise<void>;
  onCancelView?: () => void;
  onComplete: () => void;
  isWebView?: boolean;
  callback: (otp: string) => Promise<void>;
  header: string;
  title: string;
};

export const RegisterYoloOtpWebView = ({
  isLoading,
  setIsLoading,
  onSendAgain,
  onCancelView,
  onComplete,
  isWebView,
  callback,
  header,
  title,
}: RegisterYoloOtpWebViewProps) => {
  const { translation } = useLanguage();
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const otpInput = useRef<HTMLInputElement>(null);

  const confirmYoloOTP = useCallback(
    async (otpCode: string) => {
      try {
        setIsLoading(true);
        setError('');
        await callback(otpCode);
        onComplete();
      } catch (err) {
        if (window.location.href?.includes(AppRoutes.registerB2b)) {
        }
        setError(translation.loginRegister.otp.invalidCode);
      } finally {
        setIsLoading(false);
      }
    },
    [setIsLoading, setError, onComplete, translation, callback],
  );

  const updateOtp = useCallback(
    (value: string) => {
      setOtp(value);
      setError('');
      if (value.length === 6) {
        confirmYoloOTP(value);
      }
    },
    [setOtp, confirmYoloOTP],
  );

  const sendAgainClicked = useCallback(async () => {
    try {
      setIsLoading(true);
      setError('');
      setOtp('');
      await onSendAgain();
    } catch (err) {
      setError(translation.loginRegister.registerWebView.box.error);
    } finally {
      setIsLoading(false);
    }

    if (otpInput.current) {
      otpInput.current.focus();
    }
  }, [onSendAgain, setOtp, setIsLoading, setError, translation]);

  useLayoutEffect(() => {
    (global as any).$enterOtpCode = (code: string) => {
      updateOtp(code);
    };
  }, [updateOtp]);

  useEffect(() => {
    if (otpInput.current) {
      otpInput.current.focus();
    }
  }, []);

  return (
    <>
      <h3>{header}</h3>
      <p
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      ></p>

      <div className="register-page__container__box--otp--yolo-otp--email-button-container">
        <Button
          type="button"
          className="button button--text"
          onClick={onCancelView}
        >
          {translation.loginRegister.otp.webView.changeEmail}
        </Button>
      </div>

      <div className={`form-input otp-code-input ${!!error ? 'otp-code-input--error' : ''}`}>
        <div
          className="otp-code-input__value"
          onClick={() => otpInput.current?.focus()}
        >
          <span>{otp.charAt(0) || ''}</span>
          <span>{otp.charAt(1) || ''}</span>
          <span>{otp.charAt(2) || ''}</span>
          <span>{otp.charAt(3) || ''}</span>
          <span>{otp.charAt(4) || ''}</span>
          <span>{otp.charAt(5) || ''}</span>
        </div>
        <input
          ref={otpInput}
          value={otp}
          onChange={e => updateOtp(e.target.value)}
          type="number"
          pattern={'[0-9]*'}
          aria-label={translation.accessibility.code}
        />
      </div>

      {error && <div className="register-page__container__error">{error}</div>}

      <Button
        variant={'text-undecorated'}
        onClick={sendAgainClicked}
        disabled={isLoading}
      >
        {translation.loginRegister.otp.webView.sendAgain}
      </Button>
      {!isWebView && onCancelView && (
        <Button
          variant={'text'}
          onClick={onCancelView}
          disabled={isLoading}
        >
          {translation.loginRegister.otp.back}
        </Button>
      )}
    </>
  );
};
